<template>
    <div class="d-flex flex-column align-items-center">
        <h3 class="text-center">
            {{ $t('recoveruser.step3.errorHeader') }}
        </h3>
        <img class="error-image my-3" :src="warningImage" />
        <h6 class="mt-3 mb-0 text-center">{{ errorMessage }}</h6>
        <br />
        <div>
            <p class="mute caption text-center">
                {{ $t('recoveruser.step3.ifWrongContact') }}
            </p>
        </div>
        <BaseButton @click="openContactUs" variant="outline-secondary">
            {{ $t('recoveruser.step3.contactForHelp') }}
        </BaseButton>

        <BaseButton
            @click="action"
            variant="primary"
            class="mx-3 mt-4"
            style="flex-basis: 0; flex-grow: 1"
        >
            {{ actionLabel }}
        </BaseButton>
    </div>
</template>

<script>
import IntercomService from '~/services/IntercomService';

// Asset
import warningImage from '~/assets/img/warning.svg';

export default {
    name: 'ErrorIndicator',
    props: {
        errorMessage: String,
        action: {
            type: Function,
            required: true,
        },
        actionLabel: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        warningImage: warningImage,
    }),
    methods: {
        openContactUs() {
            IntercomService.show();
        },
    },
};
</script>

<style scoped>
.error-image {
    width: 200px;
    height: 200px;
}
</style>
